import { Button, Col, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import FormTimePicker from "components/form/FormProvide/FormTimePicker";

const SupEditWorkTimeForm = ({
    onSubmit = () => { },
    isOpen = false,
    onClose = () => { },
    selectedDate = "",
    selectedDateTime = "",
    selectedDateTimeEnd = "",
    formUse = null
}) => {
    const { t } = useTranslation();
    const [form] = useForm(formUse);

    useEffect(() => {
        if (isOpen) {
            const initialValues = {
                editDate: selectedDate ? dayjs(selectedDate) : null,
                startTime: selectedDateTime ? dayjs(selectedDateTime) : null,
                endTime: selectedDateTimeEnd ? dayjs(selectedDateTimeEnd) : null,
            };
            form.setFieldsValue(initialValues);
        }
    }, [isOpen, selectedDate, selectedDateTime, selectedDateTimeEnd, form]);

    return (
        <FormAntd
            form={form}
            onFinish={(values) => {
                onSubmit(values);
                form.resetFields();
                onClose();
            }}
        >
            <FormItem shouldUpdate={(prev, curv) => false}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                            <Col span={24}>
                                <FormDatePicker
                                    name="editDate"
                                    label={t("calendar.label.edit_work_hour_date")}
                                    size="large"
                                />
                            </Col>
                            <Row justify={"space-between"}>
                                <Col span={12} style={{ paddingRight: "8px" }}>
                                    <FormTimePicker
                                        name="startTime"
                                        label={t("leave_type.label.start-time")}
                                        size="large"
                                        allowClear={true}
                                    />
                                </Col>
                                <Col span={12} style={{ paddingLeft: "8px" }}>
                                    <FormTimePicker
                                        name="endTime"
                                        label={t("leave_type.label.end-time")}
                                        size="large"
                                        allowClear={true}
                                    />
                                </Col>
                            </Row>

                            <Row style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => {
                                        resetFields();
                                        onClose();
                                    }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.save").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default SupEditWorkTimeForm;